import React from 'react'
import Icon from '../Icon'

/**
* Deseret Bookshelf App Logo
*/
function BookshelfLogo(props) {
  return (
    <Icon
      icon="bookshelf-logo"
      viewBox="0 0 222 161"
      title="Deseret Bookshelf"
      description="Deseret Bookshelf logo"
      role="img"
      {...props}
    >
      <g>
        <path className="outer-headphones" d="M185.981,139.4l-6.981,0l0,-30.881l6.981,0c8.513,0 15.438,6.925 15.438,15.437c0,8.519 -6.925,15.444 -15.438,15.444m-19.556,-78.312c0,-29.963 -28.794,-48.513 -55.469,-48.513c-26.675,0 -55.475,18.55 -55.475,48.513l-4.656,0c0,-32.844 31.212,-53.169 60.131,-53.169c28.919,0 60.125,20.325 60.125,53.169l-4.656,0Zm-123.519,78.312l-6.975,0c-8.518,0 -15.443,-6.925 -15.443,-15.444c0,-8.512 6.925,-15.437 15.443,-15.437l6.975,0l0,30.881Zm143.075,-51.375l-6.981,0l0,-26.937c0,-17.269 -7.681,-33.132 -21.631,-44.675c-12.613,-10.432 -29.525,-16.413 -46.413,-16.413c-16.887,0 -33.806,5.981 -46.418,16.413c-13.944,11.543 -21.632,27.406 -21.632,44.675l0,26.937l-6.975,0c-19.812,0 -35.931,16.119 -35.931,35.931c0,19.813 16.119,35.932 35.931,35.932l27.469,0l0,-98.8c0,-25.075 24.681,-40.594 47.556,-40.594c29.369,0 47.55,21.068 47.55,40.594l0,98.8l27.475,0c19.813,0 35.932,-16.119 35.932,-35.932c0,-19.812 -16.119,-35.931 -35.932,-35.931" />
        <rect className="book-1" x="76.652" y="53.631" width="11.925" height="106.256" />
        <path className="book-2" d="M152.604,157.32l-15.462,2.994l-19.519,-104.438l15.456,-3l19.525,104.444Z" />
        <rect className="book-3" x="98.559" y="35.912" width="17.95" height="123.975" />
      </g>
    </Icon>
  )
}

export default BookshelfLogo
